import React from "react";
import { Link } from 'react-router-dom';

export default function BtnBrif(props) {
    return(
        <Link to={ props.link } className="btn btnLink">{ props.title }</Link>
    )
}